import { KnownCookies } from '@sls-react/typings/cookies';
import Cookies from 'js-cookie';

export function getKnownCookie<T extends keyof KnownCookies>(
  name: T,
): KnownCookies[T] {
  return Cookies.get(name) as KnownCookies[T];
}

export function setKnownCookie<T extends keyof KnownCookies>(
  name: T,
  value: NonNullable<KnownCookies[T]>,
  options?: Cookies.CookieAttributes,
): void {
  Cookies.set(name, value, options);
}

export function removeKnownCookie<T extends keyof KnownCookies>(
  name: T,
  options?: Cookies.CookieAttributes,
): void {
  Cookies.remove(name, options);
}
